<template>
  <div v-if="vetPrescriptionInfo && vetPrescriptionItemList">
    <my-canvas :params="params" :width="1400" />
  </div>
</template>

<script>
import myCanvas from "../myCanvas.vue";
export default {
  components: {
    myCanvas,
  },
  props: {
    vetPrescriptionItemList: {
      type: Array,
    },
    vetPrescriptionInfo: {
      type: Object,
    },
  },
  computed: {
    params() {
      if (!this.vetPrescriptionInfo) {
        return {};
      }
      return Object.assign(
        {
          rpList: (this.vetPrescriptionItemList || [])
            .map((item, i) => {
              return (
                i +
                1 +
                "." +
                [
                  item.skuInfo.goodsTitle,
                  item.skuInfo.genericName,
                  item.skuInfo.approvalNum,
                  item.skuInfo.drugDosage,
                ]
                  .filter((i) => !!i)
                  .join("/") +
                " 数量:" +
                item.goodsCount +
                (item.skuInfo.goodsUnit || "份") +
                "\n用法用量：" +
                (item.usageDosage || item.skuInfo.usageDosage || "根据说明书用量")
              );
            })
            .join("\n\n"),
        },
        this.vetPrescriptionInfo
      );
    },
  },
};
</script>
